/**
 * Escapes G-code parameter patterns that look like HTML tags
 * Handles patterns like <0-7>, R<1-3>, A<slave device address base 10>, etc.
 * Also handles malformed patterns like P<ms<] that could create invalid HTML
 */
export function escapeGcodeParameters(content: string): string {
  return (
    content
      // FIRST: Handle the specific problematic pattern that caused the error
      // P<ms<] creates an invalid HTML tag <ms<] - escape it immediately
      .replace(/P<ms<\]/g, 'P&lt;ms&lt;]')
      
      // Basic parameter ranges
      .replace(/<(0-7)>/g, '&lt;$1&gt;')
      .replace(/<(1-3)>/g, '&lt;$1&gt;')
      .replace(/<(0-255)>/g, '&lt;$1&gt;')
      .replace(/<(0 or 1)>/g, '&lt;$1&gt;')

      // Handle other malformed patterns - generalized approach
      // This pattern catches cases where there's an opening bracket followed by characters and then another < or ]
      .replace(/([A-Z])<([^<>]*<[^\]>]*[\]>])/g, '$1&lt;$2')

      // Parameters with letter prefixes (P<0-7>, R<1-3>, etc.)
      // Avoid matching closing tags like B</strong> by ensuring the bracketed content doesn't start with '/'
      .replace(/([PRBASM])<(?!\/)([^<>]+)>/g, '$1&lt;$2&gt;')

      // Complex parameter descriptions
      .replace(/<(slave device address base 10)>/g, '&lt;$1&gt;')
      .replace(/<(number of bytes)>/g, '&lt;$1&gt;')
      .replace(/<(style)>/g, '&lt;$1&gt;')
      .replace(/<(base 10)>/g, '&lt;$1&gt;')
      
      // Additional safety: catch any remaining malformed brackets that could create invalid tags
      // This handles patterns like <ms<] or <sec> that might be missed
      .replace(/<([^>]*<[^>]*[\]>])/g, '&lt;$1')
      .replace(/<(ms<|sec>)/g, '&lt;$1')
  );
}
